import React from 'react';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow} from 'material-ui/Table';

export default function IndustryLetterTab(props) {
  return (
          <div key={props.letter}>
          <Table
            multiselectable={false}
            key={props.letter}
            onRowSelection={(row) => props.onIndustrySelected(row)}>
              <TableHeader
              displaySelectAll={false}
              adjustForCheckbox={false}
              enableSelectAll={false}>
                <TableRow>
                  <TableHeaderColumn>Nimi</TableHeaderColumn>
                  <TableHeaderColumn>Hakutermit</TableHeaderColumn>
                  <TableHeaderColumn>Vanhat toimialat</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false} stripedRows={false}>
                {props.rows}
              </TableBody>
            </Table>
        </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/IndustriesPage/IndustryLetterTab.js